import { useState } from 'react';

import { isHttpsUrl, isValidURI } from ':cloud/utils/validate';

type WebhooksFormValidation = {
  urlError: string;
  validateUrl: (url: string) => void;
};

function useWebhooksURLValidation(): WebhooksFormValidation {
  const [urlError, setUrlError] = useState('');

  const validateUrl = (url: string) => {
    if (url.length > 120) {
      setUrlError('URL must be less than 120 characters');
      return;
    }

    if (!isValidURI(url)) {
      setUrlError('Please enter a valid URL');
    } else if (!isHttpsUrl(url)) {
      setUrlError('Please enter a valid HTTPS URL');
    } else {
      setUrlError('');
    }
  };

  return {
    urlError,
    validateUrl,
  };
}

export default useWebhooksURLValidation;
